module.exports = __webpack_public_path__ + "img/img-placeholder-636.d9ecb82d.png";